import React, { useEffect, useState } from "react";
import { Plus, Trash2, Tag as TagIcon } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Badge } from "../components/ui/badge";

const COLORS = ["blue", "violet", "emerald", "amber", "rose", "cyan", "orange", "slate"];
const COLOR_CLS = {
  blue: "bg-blue-100 text-blue-700", violet: "bg-violet-100 text-violet-700",
  emerald: "bg-emerald-100 text-emerald-700", amber: "bg-amber-100 text-amber-700",
  rose: "bg-rose-100 text-rose-700", cyan: "bg-cyan-100 text-cyan-700",
  orange: "bg-orange-100 text-orange-700", slate: "bg-slate-100 text-slate-700",
};

export default function Tags() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [color, setColor] = useState("blue");

  const load = async () => { const { data } = await api.get("/tags"); setItems(data); };
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!name.trim()) return;
    try { await api.post("/tags", { name, color }); setName(""); load(); toast.success("Tag creato"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const remove = async (id) => { try { await api.delete(`/tags/${id}`); load(); } catch (e) { toast.error(formatApiError(e)); } };

  return (
    <div className="space-y-6" data-testid="tags-page">
      <header>
        <h1 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight">Tag</h1>
        <p className="text-muted-foreground text-sm mt-1">Categorizza immobili, contatti e trattative.</p>
      </header>

      <Card className="border-border/60 p-4">
        <div className="flex flex-col md:flex-row gap-3">
          <Input placeholder="Nome tag (es. Luxury, Investimento, Ristrutturato…)" value={name} onChange={(e) => setName(e.target.value)} data-testid="tag-name-input" />
          <div className="flex gap-1.5">
            {COLORS.map((c) => (
              <button key={c} onClick={() => setColor(c)} className={`w-8 h-8 rounded-md border-2 ${color === c ? "border-foreground" : "border-transparent"} ${COLOR_CLS[c]}`} aria-label={c} data-testid={`color-${c}`} />
            ))}
          </div>
          <Button onClick={create} className="gap-2" data-testid="create-tag-button"><Plus className="w-4 h-4" />Crea</Button>
        </div>
      </Card>

      <Card className="border-border/60 p-6">
        {items.length === 0 ? <p className="text-sm text-muted-foreground text-center py-8">Nessun tag ancora. Creane uno.</p> : (
          <div className="flex flex-wrap gap-2">
            {items.map((t) => (
              <div key={t.id} className="group inline-flex items-center gap-1.5">
                <Badge className={`${COLOR_CLS[t.color] || COLOR_CLS.slate} border-transparent gap-1 pr-1`}>
                  <TagIcon className="w-3 h-3" />{t.name}
                  <button className="opacity-0 group-hover:opacity-100 transition-opacity ml-1 hover:text-destructive" onClick={() => remove(t.id)} data-testid={`del-tag-${t.id}`}><Trash2 className="w-3 h-3" /></button>
                </Badge>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
